import React from 'react';
import { useTranslation } from 'react-i18next';

interface ITranslation {
  /** klucz do translacji */
  id: string;
}

/** Komponent translacyjny korzystający z hooka z biblioteki react-i18next, ale zwracający przetłumaczony klucz w JSX.Element */
const Translation = ({ id }: ITranslation): JSX.Element => {
  const { t } = useTranslation();

  return <>{t(id)}</>;
};

export default Translation;
